export default __webpack_public_path__ + "/images/BlankOneMobile.daa2e40b3b68a76f1c41f77b120b7683.png";